import { isValidEmail } from '@domain-group/javascript-utils'

export type BrandModel = {
  address_line_1: string,
  address_line_2?: string,
  address_postcode: string,
  address_region: string,
  address_state: string,
  business_name?: string,
  cache_key: number,
  colour_accent?: string,
  colour_gradient_end?: string,
  colour_gradient_start?: string,
  colour_highlight?: string,
  colour_primary?: string,
  colour_secondary?: string,
  data?: {
    external_ids?: {
      realbase?: number,
    },
  },
  debtor_agency_id?: number,
  email: string,
  id: number,
  logo?: {
    small: string,
  },
  geo_country_id: number,
  hidden: boolean,
  options?: {
    artwork_builder_template_requests_enabled?: boolean,
    aml_compliance_enforcement?: boolean,
    branded_public_links?: {
      general_disclaimer: string,
      legal_disclaimer: string,
      show_inspections: boolean,
      text_accent_colour: string,
      use_light_text: boolean,
    },
    brand_controlled_image_settings_enabled?: boolean,
    brand_image_settings_excluded_agency_ids?: number[],
    cross_agency_collaboration?: boolean,
    disable_artwork_download?: boolean,
    disable_artwork_upload?: boolean,
    disable_print_quality?: boolean,
    export_settings?: {
      height?: number,
      size?: string,
      width?: number,
    },
    red_alert?: boolean,
    require_template_specialists?: boolean,
    salesforce_enabled?: boolean,
    template_designer?: boolean,
    template_page_fee?: number,
    template_page_monthly_allowance?: number,
    watermark_images?: string[],
    watermark_settings?: {
      opacity?: number,
      padding?: {
        horizontal?: number,
        vertical?: number,
      },
      position?: string,
    },
  },
  phone: string,
  realhub_platform?: string,
  salesforce_id?: string,
  title: string,
  website: string,
}

export type BrandRequestOptions = {}

const state = {
  address_line_1: '',
  address_line_2: '',
  address_postcode: '',
  address_region: '',
  address_state: '',
  business_name: '',
  colour_accent: '',
  colour_gradient_end: '',
  colour_gradient_start: '',
  colour_highlight: '',
  colour_primary: '',
  colour_secondary: '',
  data: {
    external_ids: {
      realbase_id: '',
    },
  },
  debtor_agency_id: undefined,
  email: '',
  geo_country_id: undefined,
  id: undefined,
  options: {
    artwork_builder_template_requests_enabled: true,
    branded_public_links: {
      general_disclaimer: '',
      legal_disclaimer: '',
      show_inspections: true,
      text_accent_colour: '',
      use_light_text: true,
    },
    brand_controlled_image_settings_enabled: false,
    brand_image_settings_excluded_agency_ids: [],
    cross_agency_collaboration: null,
    disable_artwork_download: null,
    disable_artwork_upload: null,
    disable_print_quality: null,
    export_settings: {
      height: 1200,
      size: 'original',
      width: 1600,
    },
    require_template_specialists: null,
    salesforce_enabled: false,
    template_designer: null,
    template_page_fee: undefined,
    template_page_monthly_allowance: undefined,
    watermark_images: [],
    watermark_settings: {
      opacity: 0.7,
      padding: {
        horizontal: 20,
        vertical: 20,
      },
      position: 'south-east',
    },
  },
  phone: '',
  salesforce_id: '',
  title: '',
  website: '',
}

export const requiredFields = [
  { key: 'address_line_1' },
  { key: 'address_region' },
  { key: 'address_postcode' },
  { key: 'address_state' },
  {
    key: 'email',
    validation: (value?: string) => isValidEmail(value),
    invalidMessage: 'Invalid format',
  },
  { key: 'geo_country_id' },
  { key: 'phone' },
  { key: 'title' },
  { key: 'website' },
]

export default state
